module.exports = __webpack_public_path__ + "static/media/portfolio1 (54).69efc5f9.jpeg";